import { IEnvVars } from 'shared/utils';

const DEV_ENV_VARS: IEnvVars = {
  API_ENDPOINT: 'https://rdr-web-exp-api-dev.qaerospace1.honaero.com',
  ASDS_ENDPOINT: 'https://dasds.honaero.com:8980/ads/broadcast/message',
  ASDS_ERROR_ENDPOINT:
    'https://stage-aerospace.honaero.com/en/secure/learn/products/weather-radar/rdr-7000/software-configuration',
  ASDS_GET_HELP: 'https://aerospace.honeywellaerospace.com/en/pages/rdr-7k-support',
};

export default DEV_ENV_VARS;
